import React from 'react';
export function ProblemSection() {
  return <section className="w-full bg-black py-16 px-4 pt-[0px] pb-[0px]" data-id="element-234">
      <div className="max-w-3xl mx-auto text-center" data-id="element-235">
        <h2 className="text-2xl sm:text-3xl font-bold text-white mb-8" data-id="element-236">
          Si sos profe de tango en Argentina,
          <br data-id="element-237" />
          <span className="text-[#FFD700]" data-id="element-238">esto te va a sonar familiar:</span>
        </h2>

        <div className="space-y-3 text-left mb-10" data-id="element-239">
          <div className="flex items-center gap-3 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl px-4 py-3" data-id="element-240">
            <span className="text-[#FF0000] text-xl flex-shrink-0" data-id="element-241">❌</span>
            <p className="text-white text-base" data-id="element-242">
              Domingo a la noche buscando material sin progresión pedagógica
              real
            </p>
          </div>
          <div className="flex items-center gap-3 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl px-4 py-3" data-id="element-243">
            <span className="text-[#FF0000] text-xl flex-shrink-0" data-id="element-244">❌</span>
            <p className="text-white text-base" data-id="element-245">
              Llegás al lunes con algo que "más o menos sirve" y se nota
            </p>
          </div>
          <div className="flex items-center gap-3 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl px-4 py-3" data-id="element-246">
            <span className="text-[#FF0000] text-xl flex-shrink-0" data-id="element-247">❌</span>
            <p className="text-white text-base" data-id="element-248">
              Siempre las mismas correcciones improvisadas en el momento
            </p>
          </div>
          <div className="flex items-center gap-3 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl px-4 py-3" data-id="element-249">
            <span className="text-[#FF0000] text-xl flex-shrink-0" data-id="element-250">❌</span>
            <p className="text-white text-base" data-id="element-251">
              Temas difíciles (disociación, pivot, musicalidad) sin saber cómo
              secuenciarlos
            </p>
          </div>
          <div className="flex items-center gap-3 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl px-4 py-3" data-id="element-252">
            <span className="text-[#FF0000] text-xl flex-shrink-0" data-id="element-253">❌</span>
            <p className="text-white text-base" data-id="element-254">
              Alumnos de distintos niveles y cero material diferenciado
            </p>
          </div>
          <div className="flex items-center gap-3 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl px-4 py-3" data-id="element-255">
            <span className="text-[#FF0000] text-xl flex-shrink-0" data-id="element-256">❌</span>
            <p className="text-white text-base" data-id="element-257">
              El 70% abandona antes del año y no sabés cómo prevenirlo
            </p>
          </div>
          <div className="flex items-center gap-3 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl px-4 py-3" data-id="element-258">
            <span className="text-[#FF0000] text-xl flex-shrink-0" data-id="element-259">❌</span>
            <p className="text-white text-base" data-id="element-260">
              No podés justificar un aumento porque no tenés un sistema
              profesional visible
            </p>
          </div>
          <div className="flex items-center gap-3 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl px-4 py-3" data-id="element-261">
            <span className="text-[#FF0000] text-xl flex-shrink-0" data-id="element-262">❌</span>
            <p className="text-white text-base" data-id="element-263">
              Fin de semana agotado y el domingo volvés a empezar de cero
            </p>
          </div>
        </div>

        <p className="text-[#FFD700] text-2xl sm:text-3xl font-black mb-8" data-id="element-264">
          ¿Cuántos domingos más vas a perder haciendo lo mismo?
        </p>

        <div className="h-px bg-gradient-to-r from-transparent via-[#FFD700] to-transparent w-full" data-id="element-265" />
      </div>
    </section>;
}